import StoryCard from "./components/StoryCard";
import { useState, useEffect } from "react";
import axios from "axios";

const Story = () => {
  const [storyData, setStoryData] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await axios.get(
        `${import.meta.env.VITE_BASE_URL}/stories/recent`
      );
      //Filtering object with garbage data
      setStoryData(
        data.stories.filter(
          (story) =>
            story.tx_hash !==
            "0xeda3447756010a10f92f27a8f30c90db3d938346637946ea5654f898beb9afc2"
        )
      );
    })();
  }, []);

  return (
    <div className="story-collection container">
      <div>
        <div className="heading--text">Gangsters & Detectives Stories</div>
        <p className="story--subtitle">
          Stories are a collection of text that the owners can add to their
          GangstaBet NFTs. Along with names & skills, Stories will add a new
          dimension of uniqueness, desirability & expression for each individual
          character.
        </p>
      </div>
      {storyData?.slice(0, 3).map((item, index) => {
        return (
          <StoryCard
            image={item.token.token_uri}
            title={item.token.token_name}
            desc={item.story}
            level={item.token.class_type}
            link={`https://gangstabet.io/profile/${item.token.token_id}`}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default Story;
